export class BulkAttachPasswordHistoryEntry {
    actorId: number;
    data: string;
}